import { Component } from '@angular/core';

@Component({
  selector: 'app-order-details-events-info',
  templateUrl: './order-details-events-info.component.html',
  styleUrls: ['./order-details-events-info.component.scss']
})
export class OrderDetailsEventsInfoComponent {

}
